import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import {
  finleyAssertUnreachable,
  utils as commonUtils,
} from '@finley-technologies/common';
import { Date } from '@finley-technologies/finley-types';

import { Select } from 'packages/common-frontend/components/Select';

type CalendarWeekProps = {
  reportingPeriod: Date.Reporting.CalendarWeek;
  setReportingPeriod: (reportingPeriod: Date.Reporting.ReportingPeriod) => void;
};
const CalendarWeek = ({
  reportingPeriod,
  setReportingPeriod,
}: CalendarWeekProps) => {
  const selectOptions: {
    value: Date.Day;
    label: Date.Day;
  }[] = Date.DayIterable.map((el) => ({ value: el, label: el }));

  return (
    <Box mt="24px">
      <Text w="xs" fontWeight={500} mb="16px">
        Start Day Of Week
      </Text>
      <Select
        value={reportingPeriod.weekStartDay ?? 'Monday'}
        onChange={(val) => {
          if (val) {
            setReportingPeriod({ ...reportingPeriod, weekStartDay: val });
          }
        }}
        options={selectOptions}
        width="xl"
      />
    </Box>
  );
};

type PeriodConfigProps = {
  reportingPeriod: Date.Reporting.ReportingPeriod;
  setReportingPeriod: (reportingPeriod: Date.Reporting.ReportingPeriod) => void;
};
const PeriodConfig = ({
  reportingPeriod,
  setReportingPeriod,
}: PeriodConfigProps) => {
  switch (reportingPeriod.period) {
    case 'calendarWeek':
      return (
        <CalendarWeek
          reportingPeriod={reportingPeriod}
          setReportingPeriod={setReportingPeriod}
        />
      );
    case 'calendarDay':
    case 'calendarMonth':
    case 'calendarQuarter':
    case 'calendarYear':
      return null;
    default:
      return finleyAssertUnreachable(reportingPeriod);
  }
};

type ReportingPeriodProps = {
  reportingPeriod: Date.Reporting.ReportingPeriod;
  setReportingPeriod: (reportingPeriod: Date.Reporting.ReportingPeriod) => void;
};
export const ReportingPeriod = ({
  reportingPeriod,
  setReportingPeriod,
}: ReportingPeriodProps) => {
  const selectOptions: {
    value: Date.Reporting.Period;
    label: Date.Reporting.Period;
  }[] = Date.Reporting.PeriodIterable.map((el) => ({ value: el, label: el }));

  return (
    <Flex flexDir="column" width="full">
      <Text fontWeight="bold" mb="3">
        Reporting Period Config
      </Text>

      <Flex alignItems="center" mb="3">
        <Text w="xs">Period:</Text>
        <Select
          value={reportingPeriod.period}
          onChange={(val) => {
            if (val) {
              setReportingPeriod({ ...reportingPeriod, period: val });
            }
          }}
          options={selectOptions}
          width="xl"
        />
      </Flex>

      <PeriodConfig
        reportingPeriod={reportingPeriod}
        setReportingPeriod={setReportingPeriod}
      />
    </Flex>
  );
};

export const LenderReportingPeriod = ({
  reportingPeriod,
  setReportingPeriod,
}: ReportingPeriodProps) => {
  const selectOptions: {
    value: Date.Reporting.Period;
    label: string;
  }[] = Date.Reporting.PeriodIterable.map((el) => ({
    value: el,
    label: commonUtils.toTitleCase(el),
  }));

  return (
    <Box w="100%">
      <Select
        value={reportingPeriod.period}
        onChange={(val) => {
          if (val) {
            setReportingPeriod({ ...reportingPeriod, period: val });
          }
        }}
        options={selectOptions}
        width="xl"
      />

      <PeriodConfig
        reportingPeriod={reportingPeriod}
        setReportingPeriod={setReportingPeriod}
      />
    </Box>
  );
};
